import { createTRPCProxyClient, httpLink } from '@trpc/client'
import type { AppRouter } from '../../../server_node/src/trpc/router'
import posthog from 'posthog-js'

export const trpc = createTRPCProxyClient<AppRouter>({
    links: [
        httpLink({
            url: `${process.env.REACT_APP_NODE_SERVER_URL}/trpc`,
            fetch(url, options) {
                return fetch(url, {
                    ...options,
                    credentials: 'include', // Include cookies for Better Auth sessions
                })
            },
            async headers() {
                const headers: Record<string, string> = {}

                // Add PostHog session info for server-side event tracking
                try {
                    const sessionId = posthog.get_session_id()
                    const distinctId = posthog.get_distinct_id()
                    if (sessionId) headers['x-posthog-session-id'] = sessionId
                    if (distinctId)
                        headers['x-posthog-distinct-id'] = distinctId
                } catch (error) {
                    // PostHog might not be initialized yet, that's ok
                    console.debug(
                        'PostHog session info not available:',
                        error
                    )
                }

                return headers
            },
        }),
    ],
})
